export default __webpack_public_path__ + "static/media/soko-download.9b94dd09.png";